// One gutter for the chat-action dialogs (2026-10-06). Every value is an
// arbitrary Tailwind value on purpose: Bootstrap ships px-5 / py-4 / gap-3 /
// mt-3 with !important and different sizes, and those win on a dialog portaled
// to <body> (design doc: "Bootstrap trap ... Use arbitrary values").
export const DLG = {
  head: 'px-[24px] py-[16px]',
  body: 'px-[24px] py-[16px]',
  // Phones (< 640px): buttons stack full width, primary on top. Wider: one
  // right-aligned row that wraps whole buttons, never their labels.
  foot: 'flex flex-col-reverse items-stretch gap-[8px] sm:flex-row sm:flex-wrap sm:items-center sm:justify-end px-[24px] py-[16px] border-t border-neutral-100',
  // A list row the teacher picks (homework, diagnostic, student).
  row: 'w-full text-left px-[16px] py-[12px] rounded-[8px] ring-1 ring-inset ring-neutral-300 hover:ring-neutral-400 border-0 bg-white hover:bg-neutral-50 cursor-pointer',
};
